import React, { Component, Fragment } from 'react'
import Avatar from '../Avatar'

type Props = {
  title: string,
  councillorName: string,
  councillorWard: string,
  metricValue: string | number,
  metricLabel?: string
}

class CityMetric extends Component<Props> {
  render() {
    const {
      title,
      councillorName,
      councillorWard,
      metricLabel,
      metricValue,
    } = this.props

    return (
      <Fragment>
        <div className='gray mv3 pt3 bt b--light-gray'>{title}</div>
        <div className='flex'>
          <div className='dib v-mid'>
            <Avatar />
          </div>
          <div className='dib ml2 v-mid'>
            <div className='f4'>{councillorName}</div>
            <div className='f6 gray'>{councillorWard}</div>
          </div>
          <div className='v-top flex-auto pr2 tr'>
            <div className='f3'>{metricValue}</div>
            {metricLabel &&
              <div className='gray'>{metricLabel}</div>
            }
          </div>
        </div>
      </Fragment>
    )
  }
}

export default CityMetric



// WEBPACK FOOTER //
// ./src/components/CityMetric/CityMetric.js